import Retweet from '../assets/retweet1.svg';

export function RetweetIcon({ className = '' }: { className?: string }) {
    return <img className={className} src={Retweet} alt='retweet' />;
}
